import React from "react";
import AuthFailed from "../components/AuthFailed/AuthFailed";

function AuthFailedPage() {
  return <AuthFailed></AuthFailed>
}

export default AuthFailedPage;
